/* Thread N Cloud v2.2: scroll reveal + "On this page" highlighting */
(function () {
  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  var reveal = root.classList.contains('js-reveal');
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var items = reveal ? document.querySelectorAll('[data-reveal]') : [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    // safety: never leave content hidden
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-visible'); }); }, 4000);

    var links = document.querySelectorAll('[data-toc-link]');
    if (links.length) {
      var map = {};
      links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { links.forEach(function (a) { a.classList.remove('is-active'); }); var a = map[e.target.id]; if (a) a.classList.add('is-active'); }
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      Object.keys(map).forEach(function (id) { var s = document.getElementById(id); if (s) tio.observe(s); });
    }
  });
})();
